export default __webpack_public_path__ + "static/media/penarikan.8240f58f.webp";